import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from '../dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { sessionStorage } from 'src/app/localstorage.service';
import * as moment from 'moment';
import { ChangeStatusComponent } from '../purchase/change-status/change-status.component';
import { ImageModuleComponent } from '../image-module/image-module.component';


@Component({
  selector: 'app-inventory-transaction-modal',
  templateUrl: './inventory-transaction-modal.component.html',
  styleUrls: ['./inventory-transaction-modal.component.scss']
})
export class InventoryTransactionModalComponent implements OnInit {


  savingFlag: boolean = false;
  segment: any = {};
  category: any = {};
  loader: boolean = false;
  filter:any={};


  userData: any;
  userId: any;

  today_date: any;
  inventoryTransaction:any=[]
  segmentList:any=[];

  inventoryTab_type='Add Inventory';
  dr_id:any;
  product_id:any;

  page_limit: any;
  start: any = 0;
  pagenumber: any = 1;
  total_page: any;
  pageCount: any;
  sr_no: any = 0;
  tab_count: any;


 warehouseType:any=['Both'];
 inventoryPurchase:any=[];
 url:any;
 downurl: any = '';





  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog, public serve: DatabaseService, public session: sessionStorage, public toast: ToastrManager,public alert : DialogComponent , public dialogRef: MatDialogRef<InventoryTransactionModalComponent>,) {
    this.url = this.serve.uploadUrl + 'influencer_doc/'
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    this.dr_id = this.data.dealer_id;
    this.product_id = this.data.product_id;
    this.page_limit = serve.pageLimit;
    this.today_date = new Date();
    this.warehouseType.push(this.data.warehouse_type)
    this.downurl = serve.downloadUrl;


    this.getInventoryTransaction();
    this.getSegment();

  }

  ngOnInit() {
  }

  refresh(){
    this.filter={};
    this.getInventoryTransaction();

  }


  pervious() {
    this.start = this.start - this.page_limit;
    this.getInventoryTransaction();
  }

  nextPage() {
    this.start = this.start + this.page_limit;
    this.getInventoryTransaction();
  }


  public onDate(event) {

    if (this.filter.inventory_date) {
      this.filter.inventory_date = moment(event.value).format('YYYY-MM-DD');
    }
    if (this.filter.date_created) {
      this.filter.date_created = moment(event.value).format('YYYY-MM-DD');
    }
    if (this.filter.invoice_date) {
      this.filter.invoice_date = moment(event.value).format('YYYY-MM-DD');
    }
    this.getInventoryTransaction();
  }


  getInventoryTransaction() {
    if (this.pagenumber > this.total_page) {
      this.pagenumber = this.total_page;
      this.start = this.pageCount - this.page_limit;
    }
    if (this.start < 0) {
      this.start = 0;
    }
    this.loader = true;

    this.filter.inventory_type=this.inventoryTab_type
    this.filter.warehouse_type =this.warehouseType;
    this.serve.post_rqst({'dealer_id':this.dr_id,'product_id':this.product_id,'filter':this.filter,'start': this.start, 'pagelimit': this.page_limit}, "Influencer/inventory_transaction_dealer_wise").subscribe((resp => {

      if (resp['statusCode'] == 200) {
        this.inventoryTransaction = resp['inventory_list'];
        this.inventoryPurchase = resp['purchase_detail'];

        this.pageCount = resp['count'];
        this.tab_count = resp['tab_count'];
       this.loader = false;


       if (this.pagenumber > this.total_page) {
        this.pagenumber = this.total_page;
        this.start = this.pageCount - this.page_limit;
      }
      else {
        this.pagenumber = Math.ceil(this.start / this.page_limit) + 1;
      }
      this.total_page = Math.ceil(this.pageCount / this.page_limit);
      this.sr_no = this.pagenumber - 1;
      this.sr_no = this.sr_no * this.page_limit;

      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }

    }));
  }

  getSegment() {
    setTimeout(() => {
      this.serve.post_rqst({}, "Master/getProductCategoryList").subscribe((result => {
        if (result['category_list']['statusCode'] == 200) {
          this.segmentList = result['category_list']['segment_list'];
        }
      }))
    }, 2000);

  }


  showItems(data){
    const dialogRef = this.dialog.open(ChangeStatusComponent, {
      width: '500px',
      panelClass:'cs-modal',
      data:{
        itemData: data,
        from_Item: 'purchase-item'
      }

    });
    dialogRef.afterClosed().subscribe(result => {

    });

  }

  goToImage(image)
  {
    const dialogRef = this.dialog.open(ImageModuleComponent, {
      panelClass:'Image-modal',
      data:{
        'image':image,
        'type':'base64'
      }});
      dialogRef.afterClosed().subscribe(result => {
      });
    }


    downloadtransactionExcel() {

      if(this.inventoryTab_type!='Purchase'){
        this.loader = true;
        this.filter.dealer_id = this.dr_id;
        this.serve.post_rqst({'dealer_id':this.dr_id,'product_id':this.product_id, 'filter': this.filter }, "Excel/inventory_transaction_dealer_wise_excel").subscribe((result) => {
          if (result['msg'] == true) {
            this.loader = false;
            console.log(result)
            window.open(this.downurl + result['filename'])
          } else {
            this.loader = false;
          }
        }, err => {
          this.loader = false;

        });

      }

      else{

        this.loader = true;
        this.filter.dealer_id = this.dr_id;
        this.serve.post_rqst({'dealer_id':this.dr_id,'product_id':this.product_id, 'filter': this.filter }, "Excel/inventory_transaction_dealer_wise_purchase_excel").subscribe((result) => {
          if (result['msg'] == true) {
            this.loader = false;
            console.log(result)
            window.open(this.downurl + result['filename'])
          } else {
            this.loader = false;
          }
        }, err => {
          this.loader = false;

        });

      }

    }



}
